export interface State {
    code: string;
    desc: string;
}
